module.exports = __webpack_public_path__ + "static/media/HortonPlains.f435f56b.png";